export const INIT = '[asset-landing]INIT';
export const AUTH_BY_TOKEN = '[asset-landing]AUTH_BY_TOKEN';
export const GET_LOGGED_IN_SESSION = '[asset-landing]GET_LOGGED_IN_SESSION';
export const DOWNLOAD_RATES_CONTRACT = '[asset-landing]DOWNLOAD_RATES_CONTRACT';
export const GET_ASSETS = '[asset-landing]GET_ASSET';
export const GET_MORE_CONTRACT_INFO = '[asset-landing]GET_MORE_CONTRACT_INFO';
export const CHANGE_CONTRACT_STATUS = '[asset-landing]CHANGE_CONTRACT_STATUS';
export const OPEN_DIALOG = '[asset-landing]OPEN_DIALOG';
export const CLOSE_DIALOG = '[asset-landing]CLOSE_DIALOG';
export const UPDATE_PROPS_DIALOG = '[asset-landing]UPDATE_PROPS_DIALOG';
export const LOG_IN = '[asset-landing]LOG_IN';
export const SIGN_UP = '[asset-landing]SIGN_UP';
export const AUTO_LOGIN = '[asset-landing]AUTO_LOGIN';
export const SCHEDULE_DEMO = '[asset-landing]SCHEDULE_DEMO';
export const REQUEST_EZ_LOAD = '[asset-landing]REQUEST_EZ_LOAD';
export const SEND_RATES = '[asset-landing]SEND_RATES';
export const SEND_RATES_FOR_ONE_REQUEST = '[asset-landing]SEND_RATES_FOR_ONE_REQUEST';
export const GET_XLS = '[asset-landing]GET_XLS';
export const DOWNLOAD_ALL_CURRENT = '[asset-landing] DOWNLOAD_ALL_CURRENT';
export const DOWNLOAD_ALL = '[asset-landing] DOWNLOAD_ALL';
export const DOWNLOAD_ALL_OUTDATED = '[asset-landing] DOWNLOAD_ALL_OUTDATED';



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/__storeFiles__/constants.js